<template>
	<div class="container-fluid">
		<nav class="navbar navbar-expand-lg navbar-light bg-light" ng-controller="navCtrl" :class="{'navbar-open':navbarOpen}">

			<span class="navbar-brand">{{company_name}}</span>
			<button class="navbar-toggler" @click="navbarOpen=!navbarOpen" type="button" data-toggle="collapse" data-target="#myNavbar" aria-controls="myNavbar" v-bind:aria-expanded="navbarOpen" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>

			<div class="collapse navbar-collapse" id="myNavbar" :class="{'show':navbarOpen}">
				<ul class="navbar-nav mr-auto" auto-active>
					<li class="nav-item"><a class="nav-link" href="#/">Home</a></li>
					<li class="nav-item"><a class="nav-link" href="#/backoffice/signatures">Signatures</a></li>
					<li class="nav-item"><a class="nav-link" href="#/backoffice/statistics">Statistics</a></li>
					<li class="nav-item"><a class="nav-link" href="#/backoffice/templates">Templates</a></li>
					<li class="nav-item" v-if="isAdmin"><a class="nav-link" href="#/backoffice/admin">Admin</a></li>
				</ul>
				<ul class="nav navbar-nav navbar-right">
					<li v-if="!loginAs" class="nav-item"><a href="#/front/login"><i class="fas fa-sign-out-alt"></i> Logout</a></li>
					<li v-if="loginAs" class="nav-item"><a href="#" v-on:click="logoutAs()"><i class="fas fa-sign-out-alt"></i> Logout from {{company_name}}</a>
					</li>
				</ul>
			</div>
		</nav>
		<transition name="page"
		            mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>
<style>
	.page-enter-active {
		transition: transform 0.2s;
	}

	.page-leave-active {
		transition: transform 0.3s;
	}

	.page-enter {
		transform: translateX(100%);
	}

	.page-leave-to {
		transform: translateX(-100%);
	}
</style>
<script>
	import ApiService from "../libs/ApiService";

	export default {
		name: "BackofficeTpl",
		data() {
			return {
				navbarOpen: true
			}
		},
		//https://stackoverflow.com/questions/43270159/vue-js-2-how-to-watch-store-values-from-vuex
		computed: {
			company_name() {
				return this.$store.state.me.user.company_name
			},
			loginAs() {
				return this.$store.state.me.user.loginAs
			},
			isAdmin() {
				return this.$store.state.me.user.isAdmin
			},
		},
		//https://stackoverflow.com/questions/43270159/vue-js-2-how-to-watch-store-values-from-vuex
		watch: {
			company_name(newValue, oldValue) {
			},
			loginAs(newValue, oldValue) {
			},
			isAdmin(newValue, oldValue) {
			},
		},
		methods: {
			async logoutAs() {
				await ApiService.post('/auth/logoutAs');
				await this.$store.dispatch("me/loadFromServer");
				this.$router.push("/backoffice/admin");
			}
		}
	}
</script>